import InfiniteScroll from 'infinite-scroll'
import Countdown from "@weseus/cms-core/assets/js/front/countdown";

export default class CategoryInfScroll {

	infScroll = null;

	constructor(naja) {
		naja.addEventListener('init', this._init.bind(this));
		naja.snippetHandler.addEventListener('afterUpdate', this._init.bind(this));
	}

	_init() {
		if (this.infScroll !== null) {
			this.infScroll.destroy();
		}

		const nextEl = document.querySelector('.pagination__next');
		let link = nextEl.href;

		const firstPage = parseInt(nextEl.getAttribute('data-page'));

		let elem = document.querySelector('.s_products');
		this.infScroll = new InfiniteScroll( elem, {
			path: function () {
				return link.replace('---PAGE---', this.pageIndex + firstPage);
			},
			append: '.c_product',
			status: '.page-load-status',
			fetchOptions: {
				headers: {
					'infScroll': '1',
				},
			},
		});

		this.infScroll.on( 'append', () => {
			const countdowns = document.querySelectorAll('[data-countdown]');
			countdowns.forEach((countdownBlock) => {
				if (countdownBlock.Countdown) return;
				new Countdown(countdownBlock);
			});
		});
	}

}

